import { useState } from 'react'
import { CheckCircle2, ExternalLink } from 'lucide-react'

import getAdditionalDocumentUrl from '../../services/get-document-url'
import openUrlInNewTab from '../../../../../../helpers/open-url-in-new-tab'

const AnalyzedView = ({ title, submittedKey, requestKey }) => {
    const [isViewLoading, setIsViewLoading] = useState(false)

    // The document lives under S3 assets/private and can only be opened with a presigned URL,
    // fetched lazily on click.
    // The tab is opened inside the click (see openUrlInNewTab) so the pop-up blocker allows it.
    const handleView = () => {
        if (!submittedKey || isViewLoading) return
        setIsViewLoading(true)
        openUrlInNewTab(async () => (await getAdditionalDocumentUrl({ requestKey, documentKey: submittedKey }))?.url)
            .catch(() => {
                // Best-effort — the document could not be resolved.
            })
            .finally(() => setIsViewLoading(false))
    }

    return (
        <div className="flex items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">

                {title && (
                    <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
                )}

                <div className="flex items-start gap-4 rounded-xl border border-green-200 bg-green-50 p-5">
                    <CheckCircle2 className="text-green-600 flex-shrink-0 mt-0.5" size={22} />
                    <div className="space-y-2">
                        <p className="text-green-800 font-semibold text-base">
                            Document already submitted and analyzed
                        </p>
                        <p className="text-green-700 text-sm">
                            This document has been successfully submitted and processed. No further action is needed.
                        </p>
                        {submittedKey && (
                            <button
                                type="button"
                                onClick={handleView}
                                disabled={isViewLoading}
                                className="inline-flex items-center gap-1.5 text-blue-600 hover:text-blue-800 text-sm font-medium mt-1 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <ExternalLink size={15} />
                                {isViewLoading ? 'Opening…' : 'View submitted document'}
                            </button>
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AnalyzedView
